import type { UserProfile } from 'firebase/auth';
import { onDisconnect, ref, update } from 'firebase/database';
import { useEffect } from 'react';

import { db } from '../firebase';

export const useUserPresence = (userProfile: UserProfile | null) => {
  useEffect(() => {
    if (!userProfile?.userId) {
      return;
    }

    const userRef = ref(db, `users/${userProfile.userId}`);
    const userData = {
      online: true,
      lastSeen: new Date().toISOString(),
      name: `${userProfile.firstName} ${userProfile.lastName}`,
      avatar: userProfile.imageUrl || '',
    };

    // Update presence when component mounts
    update(userRef, userData);

    // Set up disconnect handler
    onDisconnect(userRef).update({
      online: false,
      lastSeen: new Date().toISOString(),
    });

    // Cleanup when component unmounts
    return () => {
      update(userRef, {
        online: false,
        lastSeen: new Date().toISOString(),
      });
    };
  }, [userProfile]);
};
